/**
 * Barrel export for the API layer. Mirrors trade01's lib/api/index.ts.
 *
 * Re-exports every domain function and type so callers can do either:
 *   import { getAggregatedPositions } from '@/lib/api'
 *   import { api } from '@/lib/api'; api.getAggregatedPositions(...)
 */
export * from './client'
export * from './health'
export * from './income'
export * from './positions'
export * from './plans'
export * from './auth'
export * from './live'
export * from './runs'
export * from './autotune'
export * from './briefs'
export * from './tracker'
export * from './ghosts'
export * from './ledger'
export * from './execEvents'
export * from './optionsChain'
export * from './risk'
export * from './baseSelector'
export * from './settings'

import * as health from './health'
import * as positions from './positions'
import * as plans from './plans'
import * as auth from './auth'
import * as live from './live'
import * as runs from './runs'
import * as autotune from './autotune'
import * as briefs from './briefs'
import * as tracker from './tracker'
import * as ghosts from './ghosts'
import * as ledger from './ledger'
import * as execEvents from './execEvents'
import * as optionsChain from './optionsChain'
import * as risk from './risk'
import * as baseSelector from './baseSelector'
import * as settings from './settings'
import { apiGet, apiPost, apiPut, apiDelete } from './client'

export const api = {
  ...health,
  ...positions,
  ...plans,
  ...auth,
  ...live,
  ...runs,
  ...autotune,
  ...briefs,
  ...tracker,
  ...ghosts,
  ...ledger,
  ...execEvents,
  ...optionsChain,
  ...risk,
  ...baseSelector,
  ...settings,
  get: apiGet,
  post: apiPost,
  put: apiPut,
  delete: apiDelete,
}
